var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { observer } from "mobx-react";
import "./index.css";
import Formula from "./view/Formula";
import FormulaInput from "./view/FormulaInput";
import FormulaForm from "./view/FormulaForm";
import Table from "./view/Table";
import Chart from "./view/Chart";
import Panel from "./view/Panel";
import { provideReactivepad, withReactivepad } from "./view/ReactivepadContext";
import { Store, FormulaModel, TableModel, ChartModel } from "./store";
import authProvider from "./core/authProvider";
import { APP_NAME, NODE_TYPES, formatters, errors, FORMULA_COMPLETION_TYPES } from "./core/common";
import { getFormattedValue, renderPlainTable, renderPlainTableAsStatic, renderPlainTableAsDOM, stringToHTML } from "./core/utils";
import { SUPPORTED_FUNCTIONS, MOST_COMMON_FUNCTIONS } from "./core/functions";

export var components = {
  Formula: Formula,
  Table: Table,
  Chart: Chart,
  FormulaInput: FormulaInput,
  FormulaForm: FormulaForm,
  Panel: Panel
};

export { provideReactivepad, withReactivepad, getFormattedValue, renderPlainTable, renderPlainTableAsStatic, renderPlainTableAsDOM, stringToHTML, APP_NAME, NODE_TYPES, formatters, errors, FORMULA_COMPLETION_TYPES, Store, FormulaModel, TableModel, ChartModel, observer, SUPPORTED_FUNCTIONS, MOST_COMMON_FUNCTIONS };

export var createStore = function createStore(snapshot) {
  var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Store.create(snapshot, _extends({ authProvider: authProvider }, env));
};